import none from '../../img/leoLogo.png'
import strabericoffee from "../../img/icecoffee/strabericoffee.jpg"

export const iceCoffee=[
    {
      "id": "141",
      "title": "آیس کارامل ماکیاتو",
      "desciption": "",
      "price": "147",
      "image": none
    },
    {
      "id": "142",
      "title": "آیس لته",
      "desciption": "",
      "price": "147",
      "image": none
    },
    {
      "id": "143",
      "title": "فراپه قهوه",
      "desciption": "اسپرسو دبل-شیر-بستنی وانیل-یخ-خامه",
      "price": "170",
      "image": none
    },
    {
      "id": "144",
      "title": "بلوکافی",
      "desciption": "بلوکاراسوا-شیر-اسپرسو-یخ",
      "price": "156",
      "image": none
    },
    {
      "id": "145",
      "title": "آفاگاتو",
      "desciption": "2 اسکوپ بستنی وانیل-یک شات اسپرسو",
      "price": "145",
      "image": none
    },
    {
      "id": "146",
      "title": "آیس امریکانو سودا",
      "desciption": "",
      "price": "128",
      "image": none
    },
    {
      "id": "147",
      "title": "هایپ اسپرسو",
      "desciption": "",
      "price": "179",
      "image": none
    },
    {
      "id": "148",
      "title": "آیس امریکانو",
      "desciption": "",
      "price": "120",
      "image": none
    },
    {
      "id": "149",
      "title": "استرابری کافی",
      "desciption": "3 اسکوپ بستنی توت فرنگی-اسپرسو",
      "price": "145",
      "image": strabericoffee
    },
    {
      "id": "1410",
      "title": "کوک اسپرسو",
      "desciption": "",
      "price": "147",
      "image": none
    },
    {
      "id": "1411",
      "title": "آیس موکا",
      "desciption": "",
      "price": "167",
      "image": none
    },
    {
      "id": "1412",
      "title": "فراپاچینو",
      "desciption": "شیر، قهوه، بستنی وانیل، سیروپ کارامل، یخ",
      "price": "188",
      "image": none
    },
    {
      "id": "1413",
      "title": "black lemon",
      "desciption": "کوکا، لیمو، نعنا، اسپرسو",
      "price": "188",
      "image": none
    },
  ]